import { motion } from "framer-motion";
import { useAdmin } from "@/context/AdminContext";
import { useLang } from "@/context/LanguageContext";
import { AdPlayer } from "@/components/landing/AdPlayer";

export const VideoShowcase = () => {
  const { ads } = useAdmin();
  const { t } = useLang();

  return (
    <section id="work" className="relative z-10 mx-auto max-w-7xl px-6 py-28 sm:py-36" data-testid="video-showcase">
      <div className="mb-16 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-white/50">{t.work.eyebrow}</p>
          <h2 className="font-anton text-5xl leading-none tracking-tightest sm:text-7xl">{t.work.heading}</h2>
        </div>
        <p className="max-w-xs text-sm text-white/50">{t.work.helper}</p>
      </div>

      <div className="flex flex-col gap-8">
        {ads.map((ad, i) => (
          <motion.div
            key={ad.id}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          >
            <AdPlayer ad={ad} index={i} />
          </motion.div>
        ))}
        {ads.length === 0 && (
          <p className="py-20 text-center text-white/40">{t.work.empty}</p>
        )}
      </div>
    </section>
  );
};
